import React from 'react';
import { Typography } from '@mui/material';

const Reports: React.FC = () => {
  return (
    <div>
      <Typography variant="h4" component="h1" gutterBottom>
        Reports & Analytics
      </Typography>
      <Typography variant="body1">
        Financial reports and analytics will be implemented here.
      </Typography>
    </div>
  );
};

export default Reports;